import { render, staticRenderFns } from "./FilterRule.vue?vue&type=template&id=136f1a31"
import script from "./FilterRule.vue?vue&type=script&lang=js"
export * from "./FilterRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports